import {NetworkAPIVersion} from '@common/network/network.utils';

export default {
  getLibraryLocations: {
    url: 'api/account/library-locations/',
    method: 'get',
    apiVersion: NetworkAPIVersion.noVersion,
  },
};
